let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9W2lm")).then(() => parcelRequire('4bIqg'));